import { TICKETING_TOOL_VISIBILITY, TICKETING_TOOL_SET_URL, TICKETING_TOOL_ORG_DATA } from 'src/common/actions/constants';

export const setTicketingToolVisibility = (data) => async (dispatch) => {
  dispatch({
    type: TICKETING_TOOL_VISIBILITY,
    data,
  });
};

export const setTicketingToolURL = (data) => async (dispatch) => {
  dispatch({
    type: TICKETING_TOOL_SET_URL,
    data,
  });
};

export const setTicketingToolOrgData = (data) => async (dispatch) => {
  dispatch({
    type: TICKETING_TOOL_ORG_DATA,
    data,
  });
};
